import './share.less'

import {Icon, m} from '@codeurs/front'
import {css} from 'emotion'
import {Fragment, useEffect, useState} from 'react'
import {Menu, MenuDisclosure, MenuItem, useMenuState} from 'reakit'
import {facebookLink, linkedInLink, twitterLink} from 'util/share'
import {style} from 'util/style'
import {isIE} from 'util/tools'

const styles = style('share')

const viewShareLink: React.FC<{url: string; text?: string; type: string}> = ({
	url,
	type,
	text
}) => {
	return (
		<a class={styles('link').mod(type)} {...sharePlatform(url, type, text)}>
			<Icon icon={type} />
			<span>{getName(type)}</span>
		</a>
	)
}

const sharePlatform = (url, type, copy = '') => {
	if (!type) return null

	switch (type) {
		case 'facebook':
			return facebookLink(url)
		case 'twitter':
			return twitterLink(copy, url)
		case 'linkedin':
			return linkedInLink(url, copy)
	}
}
const getName = type => {
	switch (type) {
		case 'facebook':
			return 'Facebook'
		case 'twitter':
			return 'Twitter'
		case 'linkedin':
			return 'LinkedIn'
	}
}

export const Share: React.FC<{url: string; text: string}> = ({
	url,
	text,
	children,
	...props
}) => {
	if (isIE())
		return (
			<ShareIE url={url} {...props}>
				{children}
			</ShareIE>
		)
	const dropdown = useMenuState({
		unstable_animated: true
	})

	// found this online, seams to work great to make transitions with reakit #Jojo
	const transition = css`
		display: block;
		transition: transform 0.25s ease, opacity 0.25s ease;
		opacity: 1;
		&.hidden {
			display: none;
			opacity: 0;
			transform: ${dropdown.unstable_popoverStyles.transform}
				translate3d(0, -10px, 0) !important;
			transition: transform 0.25s ease, opacity 0.25s ease;
		}
	`
	return (
		<Fragment>
			<MenuDisclosure {...dropdown} {...props} title={'Share button'}>
				{children}
			</MenuDisclosure>
			<Menu
				{...dropdown}
				aria-label="Share dropdown"
				className={styles('dropdown').with(transition)}
			>
				<MenuItem {...dropdown} {...styles('dropdown-item')}>
					{viewShareLink({url, type: 'facebook', text: ''})}
				</MenuItem>
				<MenuItem {...dropdown} {...styles('dropdown-item')}>
					{viewShareLink({url, type: 'twitter', text})}
				</MenuItem>
				<MenuItem {...dropdown} {...styles('dropdown-item')}>
					{viewShareLink({url, type: 'linkedin'})}
				</MenuItem>
			</Menu>
		</Fragment>
	)
}

export const ShareIE: React.FC<{url: string}> = ({url, children, ...props}) => {
	const [isVisible, setVisible] = useState(false)

	const closeMenu = () => {
		setVisible(false)
	}

	useEffect(() => {
		if (!isVisible) return
		document.addEventListener('click', closeMenu)
		return () => {
			document.removeEventListener('click', closeMenu)
		}
	}, [isVisible])

	return (
		<Fragment>
			<button
				type="button"
				{...props}
				title={'Share button'}
				onClick={() => {
					const currentVisibility = isVisible
					setVisible(!currentVisibility)
				}}
			>
				{children}
			</button>
			{isVisible && (
				<div
					aria-label="Share dropdown"
					className={styles('dropdown').mod('IE')}
				>
					<div {...styles('dropdown-item').mod('IE')}>
						{viewShareLink({url, type: 'facebook'})}
					</div>
					<div {...styles('dropdown-item').mod('IE')}>
						{viewShareLink({url, type: 'twitter'})}
					</div>
					<div {...styles('dropdown-item').mod('IE')}>
						{viewShareLink({url, type: 'linkedin'})}
					</div>
				</div>
			)}
		</Fragment>
	)
}
